export const getPromoFromPayload = (selectedPromo) => {
    let promoPayload = "";
    if (Object.keys(selectedPromo).length === 0) {
        return promoPayload;
    }
    if (selectedPromo.selectedReferralCode) {
        promoPayload = selectedPromo.selectedReferralCode;
        return promoPayload;
    }
    if (Array.isArray(selectedPromo.eligibilityRules.codes)) {
        const getPromoPayload = selectedPromo.eligibilityRules.codes.filter(
        code => code.isPublic
        );
        if (Array.isArray(getPromoPayload) && getPromoPayload.length > 0) {
        promoPayload = getPromoPayload[0].code;
        }
    }
    return promoPayload;
};